import { render, staticRenderFns } from "./SalesMonitor.vue?vue&type=template&id=a7441b06&scoped=true&"
import script from "./SalesMonitor.vue?vue&type=script&lang=js&"
export * from "./SalesMonitor.vue?vue&type=script&lang=js&"
import style0 from "./SalesMonitor.vue?vue&type=style&index=0&id=a7441b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7441b06",
  null
  
)

export default component.exports